import {Zoom} from "react-awesome-reveal";
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import {useEffect, useState} from "react";
import {Button} from "@mui/material";
import axios from "axios";
import Alert from '@mui/material/Alert';
import {useSelector} from "react-redux";
import language from "../store/language";
import SendIcon from '@mui/icons-material/Send';
import { Modal } from "react-bootstrap";
import PrivacyPolicy from "../pages/Admin/Pages/PrivacyPolicy";
import TermsAndCond from "../pages/Admin/Components/TermsAndCond";

const SignUp = ({setShowSignup, showSignIn, setNotification}) => {
    const [showTermsAndCond, setShowTermsAndCond] = useState(false);
    const lang = useSelector((state) => state.user.language);
    const [step, setStep] = useState(0);
    const [signupForm, setSignupForm] = useState({
        email: "", password: "", repeat_password: "", username: "", user_type: "", number_of_id: "", is_resident: false,
        phone: "", name_geo: "", surname_geo: "", name_en: "", surname_en: "", address: "", city: "",
        company_name_geo: "", company_name_en: "", identification_code: "", name_of_representative: "",
        surname_of_representative: "", position_of_representative: "", id_number_of_representative: "",
        district: ""
    });
    const [accepted, setAccepted] = useState(false);
    const [validIdentification, setValidIdentification] = useState("");
    const [showVerifyPhone, setShowVerifyPhone] = useState(false);
    const [errors, setErrors] = useState({
        email: false,
        password: false,
        repeat_password: false,
        username: false,
        number_of_id: "",
        phone: false,
        name_geo: false,
        surname_geo: false,
        name_en: false,
        surname_en: false,
        id_number: false,
        company_name_geo: false,
        company_name_en: false,
        identification_code: false,
        name_of_representative: false,
        surname_of_representative: false,
        position_of_representative: false,
        id_number_of_representative: false,
        address: false,
        city: false,
        confirm_email: true,
        id_number_validation: false,
        confirm_phone: true,
        identification_code_duplicate: false,
        district: false,
        accepted: false
    });

    const districts = [
        "აბანოთუბანი", "ავლაბარი","300 არაგველი","ავჭალა","აფრიკა","აეროპორტის დასახლება","ბერი სალოსის გამზირი","გლდანი","დიდი დიღომი","დიღმის მასივი","დიდუბე","დიდუბე-ჩუღურეთი (პლეხანოვი)",
        "ვაკე","ვერა","ვაზისუბანი","ვარკეთილი","ვაშლიჯვარი","ვორონცოვი","ზაჰესი","ზეემკა","თემქა","ისანი","კონიაკის დასახლება","კრწანისი","კუკია","ლილოს დასახლება","ლოტკინი","მთაწმინდა",
        "მოსკოვის გამზირი","მუხიანი","ნაძალადევი (ნახალოვკა)","ორთაჭალა","საბურთალო","სოლოლაკი","სანზონა","სამგორი","სვანეთის უბანი","სოფელი გლდანი","სოფელი დიღომი","სოფელი ლილო","ფონიჭალა",
        "წინუბანი",
    ]
    const [verify, setVerify] = useState({email: "", phone: ""});
    const [showVerifyEmail, setShowVerifyEmail] = useState(false);
    const cities = [{"id":0,"name":"აირჩიეთ ქალაქი"},{"id":1,"name":"თბილისი"},{"id":2,"name":"აბაშა"},{"id":3,"name":"დმანისი"},{"id":4,"name":"მცხეთა"},{"id":5,"name":"ბოლნისი"},{"id":6,"name":"ხობი"},{"id":7,"name":"მარნეული"},{"id":8,"name":"წალენჯიხა"},{"id":9,"name":"მარტვილი"},{"id":10,"name":"ხონი"},{"id":11,"name":"ხაშური"},{"id":12,"name":"ჭიათურა"},{"id":13,"name":"წყალტუბო"},{"id":14,"name":"წნორი"},{"id":15,"name":"ჩოხატაური"},{"id":16,"name":"ყვარელი"},{"id":17,"name":"ქობულეთი"},{"id":18,"name":"მესტია"},{"id":19,"name":"ყაზბეგი"},{"id":20,"name":"ხულო"},{"id":21,"name":"ქედა"},{"id":22,"name":"ოჩამჩირე"},{"id":23,"name":"შუახევი"},{"id":24,"name":"ნინოწმინდა"},{"id":25,"name":"ხელვაჩაური"},{"id":26,"name":"წალკა"},{"id":27,"name":"ფოთი"},{"id":28,"name":"ხარაგაული"},{"id":29,"name":"თეთრიწყარო"},{"id":30,"name":"ჩხოროწყუ"},{"id":31,"name":"ლენტეხი"},{"id":32,"name":"ქარელი"},{"id":33,"name":"ცაგერი"},{"id":34,"name":"გარდაბანი"},{"id":35,"name":"ზესტაფონი"},{"id":36,"name":"ქუთაისი"},{"id":37,"name":"ადიგენი"},{"id":38,"name":"ამბროლაური"},{"id":39,"name":"ასპინძა"},{"id":40,"name":"ახალქალაქი"},{"id":41,"name":"ახალციხე"},{"id":42,"name":"ახმეტა"},{"id":43,"name":"ბათუმი"},{"id":44,"name":"ბაღდათი"},{"id":45,"name":"ბორჯომი"},{"id":46,"name":"გორი"},{"id":47,"name":"გურჯაანი"},{"id":48,"name":"დედოფლისწყარო"},{"id":49,"name":"დუშეთი"},{"id":50,"name":"ვანი"},{"id":51,"name":"ტყიბული"},{"id":52,"name":"ზუგდიდი"},{"id":53,"name":"თელავი"},{"id":54,"name":"თერჯოლა"},{"id":55,"name":"თიანეთი"},{"id":56,"name":"კასპი"},{"id":57,"name":"ლაგოდეხი"},{"id":58,"name":"ლანჩხუთი"},{"id":59,"name":"ოზურგეთი"},{"id":60,"name":"ონი"},{"id":61,"name":"რუსთავი"},{"id":62,"name":"საგარეჯო"},{"id":63,"name":"სამტრედია"},{"id":64,"name":"საჩხერე"},{"id":65,"name":"სენაკი"},{"id":66,"name":"სიღნაღი"}];

    useEffect(() => {
        const urlencoded = new URLSearchParams();
        urlencoded.append("country", "Georgia");
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: 'https://countriesnow.space/api/v0.1/countries/cities',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            data: urlencoded
        };
    }, []);

    const handlers = {
        sendCodeToEmail() {
            axios.post('/api/email/verify', {email: signupForm.email})
                .then((res) => {
                    setNotification({show: true, type: "success", message: "Verification code sent to your email"});
                    setTimeout(() => setNotification({show: false, type: "", message: ""}), 6000);
                    setShowVerifyEmail(true);
                })
                .catch((err) => {
                    setNotification({show: true, type: "error", message: err.response.data.status});
                    setTimeout(() => setNotification({show: false, type: "", message: ""}), 6000);
                })
        },
        sendCodeToPhone() {
            axios.post('/api/phone/verify', {phone: signupForm.phone})
                .then((res) => {
                    setNotification({show: true, type: "success", message: "Verification code sent to your phone"});
                    setTimeout(() => setNotification({show: false, type: "", message: ""}), 6000);
                    setShowVerifyPhone(true);
                })
                .catch((err) => {
                    setNotification({show: true, type: "error", message: err.response.data.status});
                    setTimeout(() => setNotification({show: false, type: "", message: ""}), 6000);
                })
        },
        confirmEmail() {
            axios.post('/api/email/confirm', {oneTimeCode: verify.email})
                .then((res) => {
                    setNotification({show: true, type: "success", message: "Email address verified"});
                    setTimeout(() => setNotification({show: false, type: "", message: ""}), 6000);
                    setErrors((prev) => ({...prev, confirm_email: false}));
                    setShowVerifyEmail(false);
                })
                .catch((err) => {
                    setNotification({show: true, type: "error", message: "Wrong verification code"});
                    setTimeout(() => setNotification({show: false, type: "", message: ""}), 6000);
                    setErrors((prev) => ({...prev, confirm_email: true}));
                })
        },
        confirmPhone() {
            axios.post('/api/phone/confirm', {oneTimeCode: verify.email})
                .then((res) => {
                    setNotification({show: true, type: "success", message: "Phone verified"});
                    setTimeout(() => setNotification({show: false, type: "", message: ""}), 6000);
                    setErrors((prev) => ({...prev, confirm_phone: false}));
                    setShowVerifyPhone(false);
                })
                .catch((err) => {
                    setNotification({show: true, type: "error", message: "Wrong verification code"});
                    setTimeout(() => setNotification({show: false, type: "", message: ""}), 6000);
                    setErrors((prev) => ({...prev, confirm_phone: true}));
                })
        },
        validate(key, value) {
            axios(`/api/signup/validate?key=${key}&value=${value}`)
                .then((res) => {
                    if (!res.data.is_valid) {
                        setErrors((prev) => ({...prev, [key]: true}))
                        setValidIdentification(res.data.message[lang])
                    } else {
                        setErrors((prev) => ({...prev, [key]: false}))
                    }
                })
                .catch(() => {
                    setErrors((prev) => ({...prev, [key]: true}))
                })
        },
        doneSecondStep() {
            if (signupForm.username !== "" && !errors.username && !errors.email && !errors.confirm_email) {
                if (signupForm.password.length < 7) {
                    setErrors((prev) => ({...prev, password: true}));
                } else if (signupForm.password !== signupForm.repeat_password) {
                    setErrors((prev) => ({...prev, repeat_password: true}));
                } else {
                    setStep(2)
                }
            }
        },
        doneThirdStepLegal(){
            if (signupForm.company_name_geo !== "" &&
                signupForm.company_name_en !== "" &&
                signupForm.identification_code !== "" &&
                signupForm.name_of_representative !== "" &&
                signupForm.surname_of_representative !== "" &&
                signupForm.position_of_representative !== "" &&
                signupForm.id_number_of_representative !== "") {
                setStep(3)
            } else {
                if (signupForm.company_name_geo === "") setErrors((prev) => ({...prev, company_name_geo: true}));
                if (signupForm.company_name_en === "") setErrors((prev) => ({...prev, company_name_en: true}));
                if (signupForm.identification_code === "") setErrors((prev) => ({...prev, identification_code: true}));
                if (signupForm.name_of_representative === "") setErrors((prev) => ({...prev, name_of_representative: true}));
                if (signupForm.surname_of_representative === "") setErrors((prev) => ({...prev, surname_of_representative: true}));
                if (signupForm.position_of_representative === "") setErrors((prev) => ({...prev, position_of_representative: true}));
                if (signupForm.id_number_of_representative === "") setErrors((prev) => ({...prev, id_number_of_representative: true}));
            }
        },
        doneThirdStep() {
            if (signupForm.name_geo !== "" && signupForm.name_en !== "" && signupForm.surname_geo !== "" && signupForm.surname_en !== "" && signupForm.number_of_id !== "" && signupForm.number_of_id.length === signupForm.is_resident ? 9 : 11) {
                setStep(3)
            } else {
                if (signupForm.name_geo === "") setErrors((prev) => ({...prev, name_geo: true}));
                if (signupForm.name_en === "") setErrors((prev) => ({...prev, name_en: true}));
                if (signupForm.surname_geo === "") setErrors((prev) => ({...prev, surname_geo: true}));
                if (signupForm.surname_en === "") setErrors((prev) => ({...prev, surname_en: true}));
                if (signupForm.number_of_id === "") setErrors((prev) => ({...prev, id_number: true}));
                if (signupForm.number_of_id.length !== 11) setErrors((prev) => ({...prev, id_number_validation: true}));
            }
        },
        signUp() {
            if (signupForm.city !== "" && signupForm.address !== "" && (signupForm.district !== "" || signupForm.city !== "Tbilisi") && errors.confirm_phone === false) {
                axios.post(`/api/${signupForm.user_type}/signup`, signupForm)
                    .then((res) => {
                        setErrors({
                            email: false,
                            password: false,
                            repeat_password: false,
                            username: false,
                            number_of_id: "",
                            phone: false,
                            name_geo: false,
                            surname_geo: false,
                            name_en: false,
                            surname_en: false,
                            id_number: false,
                            company_name_geo: false,
                            company_name_en: false,
                            identification_code: false,
                            name_of_representative: false,
                            surname_of_representative: false,
                            position_of_representative: false,
                            id_number_of_representative: false,
                            address: false,
                            city: false,
                            confirm_email: true,
                            id_number_validation: false,
                            confirm_phone: true,
                            identification_code_duplicate: false
                        });
                        setSignupForm({
                            email: "", password: "", repeat_password: "", username: "", user_type: "", number_of_id: "", is_resident: false,
                            phone: "", name_geo: "", surname_geo: "", name_en: "", surname_en: "", address: "", city: "",
                            company_name_geo: "", company_name_en: "", identification_code: "", name_of_representative: "",
                            surname_of_representative: "", position_of_representative: "", id_number_of_representative: ""
                        })
                        setStep(0);

                        setNotification({show: true, type: "success", message: res.data.message.en});
                        setShowSignup(false);
                        showSignIn(true);
                        setTimeout(() => {
                            setNotification({show: false, type: "", message: ""});
                        }, 6000);
                    })
                    .catch((err) => {
                        setNotification({show: true, type: "success", message: err.response.data.message.en});
                    })
            } else {
                if (signupForm.address === "") setErrors((prev) => ({...prev, address: true}));
                if (signupForm.city === "") setErrors((prev) => ({...prev, city: true}));
                if (signupForm.district === "") setErrors((prev) => ({...prev, district: true}));
                if(accepted == false) setErrors((prev) => ({...prev, accepted: true}))
            }
        }
    }

    return (
        <>
            <div className={"login-content"}>
                <Zoom className={"login-modal-content"}>
                    <>
                        <div className={"signup-aside-modal"}>
                            <img src={"/static/icons/logo.png"} alt={"sign up logo"} className={"login-modal-logo"}/>
                            {step === 0 && <div className={"signup-step-one"}>
                                <p className={"account-type-selector-title"}>{language[lang].auth.signUp.accountType.title}</p>
                                <div className={"account-type-selector"}>
                                    <div onClick={() => {
                                        setSignupForm((prev) => ({...prev, user_type: "physical"}));
                                        setStep(1);
                                    }}>
                                        <AccountCircleIcon style={{fontSize: "40px"}}/>
                                        <p>{language[lang].auth.signUp.accountType.physical}</p>
                                    </div>
                                    <div onClick={() => {
                                        setSignupForm((prev) => ({...prev, user_type: "legal"}));
                                        setStep(1);
                                    }}>
                                        <BusinessCenterIcon style={{fontSize: "40px"}}/>
                                        <p>{language[lang].auth.signUp.accountType.legal}</p>
                                    </div>
                                </div>
                                <div className={"return-to-sign-in"}>
                                    <p>{language[lang].auth.signUp.accountType.haveAnAccount}</p>
                                    <Button variant={"contained"} onClick={() => {
                                        setShowSignup(false);
                                        showSignIn(true);
                                    }}>{language[lang].auth.login.login}</Button>
                                </div>
                            </div>}

                            <>
                                {
                                    step === 1 && <div className={"signup-step-two"}>
                                        <div className={"form-group"} style={{marginTop: "40px"}}>
                                            <label className={"form-label"}>{language[lang].auth.signUp.accountType.username}*</label>
                                            <input type={"text"} value={signupForm.username} className={"form-control"}
                                                   onChange={(e) => setSignupForm((prev) => ({
                                                       ...prev,
                                                       username: e.target.value
                                                   }))}
                                                   placeholder={language[lang].auth.signUp.accountType.usernamePlaceholder} onBlur={() => {
                                                handlers.validate("username", signupForm.username);
                                            }}/>
                                            {errors.username &&
                                                <p className={"form-error-message"}>{language[lang].auth.signUp.accountType.errors.usernameAvailable}</p>}
                                        </div>
                                        <div className={"form-group"} style={{marginTop: "20px"}}>
                                            <label className={"form-label"}>{language[lang].auth.signUp.accountType.email}*</label>
                                            <div
                                                style={{display: "flex", alignItems: "center", justifyContent: "flex-end"}}>
                                                <input type={"email"} value={signupForm.email} className={"form-control"}
                                                       style={{paddingRight: "70px"}}
                                                       onChange={(e) => setSignupForm((prev) => ({
                                                           ...prev,
                                                           email: e.target.value
                                                       }))}
                                                       placeholder={language[lang].auth.signUp.accountType.emailPlaceholder} onBlur={() => {
                                                    handlers.validate("email", signupForm.email);
                                                }}/>
                                                <button className="verify-button" onClick={handlers.sendCodeToEmail}><SendIcon style={{color: "white"}}/>
                                                </button>
                                            </div>
                                            {errors.email && <p className={"form-error-message"}>{language[lang].auth.signUp.accountType.errors.emailAvailable}</p>}
                                            {errors.confirm_email &&
                                                <p className={"form-error-message"}>{language[lang].auth.signUp.accountType.errors.verifyEmail}</p>}
                                            {showVerifyEmail && <div style={{
                                                display: "flex",
                                                alignItems: "center",
                                                marginTop: "20px",
                                                justifyContent: "space-between"
                                            }}>
                                                <input type={"text"}
                                                       onChange={(e) => setVerify((prev) => ({
                                                           ...prev,
                                                           email: e.target.value
                                                       }))}
                                                       placeholder={"Enter code"} className={"form-control"}
                                                       style={{width: "calc(100% - 120px)"}}/>
                                                <Button onClick={handlers.confirmEmail}>{language[lang].auth.signUp.accountType.confirm}</Button>
                                            </div>}
                                        </div>
                                        <div className={"form-group"} style={{marginTop: "20px"}}>
                                            <label className={"form-label"}>{language[lang].auth.signUp.accountType.password}*</label>
                                            <input type={"password"} value={signupForm.password} className={"form-control"}
                                                   onChange={(e) => setSignupForm((prev) => ({
                                                       ...prev,
                                                       password: e.target.value
                                                   }))}
                                                   placeholder={language[lang].auth.signUp.accountType.passwordPlaceholder}/>
                                            {errors.password && <p className={"form-error-message"}>{language[lang].auth.signUp.accountType.errors.easyPassword}</p>}
                                        </div>
                                        <div className={"form-group"} style={{marginTop: "20px"}}>
                                            <label className={"form-label"}>{language[lang].auth.signUp.accountType.resetPassword}*</label>
                                            <input type={"password"} value={signupForm.repeat_password}
                                                   className={"form-control"}
                                                   onChange={(e) => setSignupForm((prev) => ({
                                                       ...prev,
                                                       repeat_password: e.target.value
                                                   }))}
                                                   placeholder={language[lang].auth.signUp.accountType.repeatPasswordPlaceholder}/>
                                            {errors.repeat_password &&
                                                <p className={"form-error-message"}>{language[lang].auth.signUp.accountType.errors.match}</p>}
                                        </div>
                                        <div className={"signup-step-buttons"}>
                                            <Button onClick={() => setStep(0)}>{language[lang].auth.signUp.accountType.prev}</Button>
                                            <Button onClick={handlers.doneSecondStep} variant={"contained"}>{language[lang].auth.signUp.accountType.next}</Button>
                                        </div>
                                    </div>
                                }
                                {
                                    (step === 2 && signupForm.user_type === "physical") && <div className={"signup-step-tree"}>
                                        <div className={"form-group"} style={{marginTop: "40px"}}>
                                            <label
                                                className={"form-label"}>{language[lang].auth.signUp.accountType.resident}</label>
                                            <div>
                                                <label className="switch">
                                                    <input type="checkbox" onChange={(e) => setSignupForm((prev) => ({
                                                        ...prev,
                                                        is_resident: e.target.checked
                                                    }))}/>
                                                    <span className="slider round"></span>
                                                </label>
                                            </div>
                                        </div>
                                        <div className={"form-group"} style={{marginTop: "40px"}}>
                                            <label
                                                className={"form-label"}>{language[lang].auth.signUp.accountType.name_geo}*</label>
                                            <input type={"text"} value={signupForm.name_geo} className={"form-control"}
                                                   onChange={(e) => {
                                                       if (/^[ა-ჰ ]*$/.test(e.target.value)) {
                                                           setSignupForm((prev) => ({
                                                               ...prev,
                                                               name_geo: e.target.value
                                                           }))
                                                       }
                                                   }}
                                                   placeholder={language[lang].auth.signUp.accountType.name_geoPlaceholder}/>
                                            {errors.name_geo &&
                                                <p className={"form-error-message"}>{language[lang].auth.signUp.accountType.errors.required}</p>}
                                        </div>
                                        <div className={"form-group"} style={{marginTop: "20px"}}>
                                            <label
                                                className={"form-label"}>{language[lang].auth.signUp.accountType.surname_geo}*</label>
                                            <input type={"text"} value={signupForm.surname_geo} className={"form-control"}
                                                   onChange={(e) => {
                                                       if (/^[ა-ჰ ]*$/.test(e.target.value)) {
                                                           setSignupForm((prev) => ({
                                                               ...prev,
                                                               surname_geo: e.target.value
                                                           }))
                                                       }
                                                   }}
                                                   placeholder={language[lang].auth.signUp.accountType.surname_geoPlaceholder}/>
                                            {errors.surname_geo &&
                                                <p className={"form-error-message"}>{language[lang].auth.signUp.accountType.required}</p>}
                                        </div>
                                        <div className={"form-group"} style={{marginTop: "20px"}}>
                                            <label
                                                className={"form-label"}>{language[lang].auth.signUp.accountType.name_en}*</label>
                                            <input type={"text"} value={signupForm.name_en} className={"form-control"}
                                                   onChange={(e) => {
                                                       if (/^[a-zA-Z ]*$/.test(e.target.value)) {
                                                           setSignupForm((prev) => ({
                                                               ...prev,
                                                               name_en: e.target.value
                                                           }))
                                                       }
                                                   }}
                                                   placeholder={language[lang].auth.signUp.accountType.name_enPlaceholder}/>
                                            {errors.name_en &&
                                                <p className={"form-error-message"}>{language[lang].auth.signUp.accountType.errors.required}</p>}
                                        </div>
                                        <div className={"form-group"} style={{marginTop: "20px"}}>
                                            <label
                                                className={"form-label"}>{language[lang].auth.signUp.accountType.surname_en}*</label>
                                            <input type={"text"} value={signupForm.surname_en} className={"form-control"}
                                                   onChange={(e) => {
                                                       if (/^[a-zA-Z ]*$/.test(e.target.value)) {
                                                           setSignupForm((prev) => ({
                                                               ...prev,
                                                               surname_en: e.target.value
                                                           }))
                                                       }
                                                   }}
                                                   placeholder={language[lang].auth.signUp.accountType.surname_enPlaceholder}/>
                                            {errors.surname_en &&
                                                <p className={"form-error-message"}>{language[lang].auth.signUp.accountType.errors.required}</p>}
                                        </div>
                                        <div className={"form-group"} style={{marginTop: "20px"}}>
                                            <label
                                                className={"form-label"}>{signupForm.is_resident ? language[lang].auth.signUp.accountType.payerNumber : language[lang].auth.signUp.accountType.idNumber}*</label>
                                            <input type={"text"} value={signupForm.number_of_id} className={"form-control"}
                                                   onChange={(e) => {
                                                       if (/^[0-9]*$/.test(e.target.value)) {
                                                           setSignupForm((prev) => ({
                                                               ...prev,
                                                               number_of_id: e.target.value
                                                           }))
                                                       }
                                                   }}
                                                   onBlur={() => {
                                                       handlers.validate("number_of_id", signupForm.number_of_id)
                                                   }}
                                                   placeholder={signupForm.is_resident ? language[lang].auth.signUp.accountType.payerNumber : language[lang].auth.signUp.accountType.idNumber}/>
                                            {errors.id_number &&
                                                <p className={"form-error-message"}>{language[lang].auth.signUp.accountType.required}</p>}
                                            {errors.id_number_validation &&
                                                <p className={"form-error-message"}>{language[lang].auth.signUp.accountType.errors.idNumber}</p>}
                                        </div>
                                        <div className={"signup-step-buttons"}>
                                            <Button
                                                onClick={() => setStep(1)}>{language[lang].auth.signUp.accountType.prev}</Button>
                                            <Button onClick={handlers.doneThirdStep} disabled={signupForm.name_geo == "" || signupForm.surname_geo == "" || signupForm.name_en == "" || signupForm.surname_en == "" || signupForm.number_of_id == ""}
                                                    variant={"contained"}>{language[lang].auth.signUp.accountType.next}</Button>
                                        </div>
                                    </div>
                                }
                                {
                                    (step === 2 && signupForm.user_type === "legal") &&
                                    <div className={"signup-step-tree"}>
                                        <div className={"form-group"} style={{marginTop: "40px"}}>
                                            <label
                                                className={"form-label"}>{language[lang].auth.signUp.accountType.companyNameGeo}*</label>
                                            <input type={"text"} value={signupForm.company_name_geo}
                                                   className={"form-control"}
                                                   onChange={(e) => {
                                                       if (/^[ა-ჰ ]*$/.test(e.target.value)) {
                                                           setErrors((prev) => ({...prev, company_name_geo: false}))
                                                           setSignupForm((prev) => ({
                                                               ...prev,
                                                               company_name_geo: e.target.value
                                                           }))
                                                       }
                                                   }}
                                                   placeholder={language[lang].auth.signUp.accountType.companyNameGeoPlaceholder}/>
                                            {errors.company_name_geo &&
                                                <p className={"form-error-message"}>{language[lang].auth.signUp.accountType.errors.required}</p>}
                                        </div>
                                        <div className={"form-group"} style={{marginTop: "20px"}}>
                                            <label
                                                className={"form-label"}>{language[lang].auth.signUp.accountType.companyNameEn}*</label>
                                            <input type={"text"} value={signupForm.company_name_en} className={"form-control"}
                                                   onChange={(e) => {
                                                       if (/^[a-zA-Z ]*$/.test(e.target.value)) {
                                                           setErrors((prev) => ({...prev, company_name_en: false}))
                                                           setSignupForm((prev) => ({
                                                               ...prev,
                                                               company_name_en: e.target.value
                                                           }))
                                                       }
                                                   }}
                                                   placeholder={language[lang].auth.signUp.accountType.companyNameEnPlaceholder}/>
                                            {errors.company_name_en &&
                                                <p className={"form-error-message"}>{language[lang].auth.signUp.accountType.errors.required}</p>}
                                        </div>
                                        <div className={"form-group"} style={{marginTop: "20px"}}>
                                            <label
                                                className={"form-label"}>{language[lang].auth.signUp.accountType.identification_code}*</label>
                                            <input type={"text"} value={signupForm.identification_code}
                                                   className={"form-control"}
                                                   onChange={(e) => {
                                                       if (/^[0-9]*$/.test(e.target.value)) {
                                                           setErrors((prev) => ({...prev, identification_code: false}))
                                                           setSignupForm((prev) => ({
                                                               ...prev,
                                                               identification_code: e.target.value
                                                           }))
                                                       }
                                                   }}
                                                   onBlur={() => handlers.validate("identification_code", signupForm.identification_code)}
                                                   placeholder={language[lang].auth.signUp.accountType.identification_codePlaceholder}/>
                                            {errors.identification_code &&
                                                <p className={"form-error-message"}>{validIdentification}</p>}
                                        </div>
                                        <div className={"form-group"} style={{marginTop: "20px"}}>
                                            <label
                                                className={"form-label"}>{language[lang].auth.signUp.accountType.name_of_representative}*</label>
                                            <input type={"text"} value={signupForm.name_of_representative}
                                                   className={"form-control"}
                                                   onChange={(e) => {
                                                       setErrors((prev) => ({...prev, name_of_representative: false}))
                                                       setSignupForm((prev) => ({
                                                           ...prev,
                                                           name_of_representative: e.target.value
                                                       }))
                                                   }}
                                                   placeholder={language[lang].auth.signUp.accountType.name_of_representativePlaceholder}/>
                                            {errors.name_of_representative &&
                                                <p className={"form-error-message"}>{language[lang].auth.signUp.accountType.errors.required}</p>}
                                        </div>
                                        <div className={"form-group"} style={{marginTop: "20px"}}>
                                            <label
                                                className={"form-label"}>{language[lang].auth.signUp.accountType.surname_of_representative}*</label>
                                            <input type={"text"} value={signupForm.surname_of_representative}
                                                   className={"form-control"}
                                                   onChange={(e) => {
                                                       setErrors((prev) => ({...prev, surname_of_representative: false}))
                                                       setSignupForm((prev) => ({
                                                           ...prev,
                                                           surname_of_representative: e.target.value
                                                       }))
                                                   }}
                                                   placeholder={language[lang].auth.signUp.accountType.surname_of_representativePlaceholder}/>
                                            {errors.surname_of_representative &&
                                                <p className={"form-error-message"}>{language[lang].auth.signUp.accountType.errors.required}</p>}
                                        </div>
                                        <div className={"form-group"} style={{marginTop: "20px"}}>
                                            <label
                                                className={"form-label"}>{language[lang].auth.signUp.accountType.position_of_representative}*</label>
                                            <input type={"text"} value={signupForm.position_of_representative}
                                                   className={"form-control"}
                                                   onChange={(e) => {
                                                       setErrors((prev) => ({...prev, position_of_representative: false}))
                                                       setSignupForm((prev) => ({
                                                           ...prev,
                                                           position_of_representative: e.target.value
                                                       }))
                                                   }}
                                                   placeholder={language[lang].auth.signUp.accountType.position_of_representativePlaceholder}/>
                                            {errors.position_of_representative &&
                                                <p className={"form-error-message"}>{language[lang].auth.signUp.accountType.errors.required}</p>}
                                        </div>
                                        <div className={"form-group"} style={{marginTop: "20px"}}>
                                            <label
                                                className={"form-label"}>{language[lang].auth.signUp.accountType.id_number_of_representative}*</label>
                                            <input type={"text"} value={signupForm.id_number_of_representative}
                                                   className={"form-control"}
                                                   onChange={(e) => {
                                                       if (/^[0-9]*$/.test(e.target.value)) {
                                                           setErrors((prev) => ({...prev, id_number_of_representative: false}))
                                                           setSignupForm((prev) => ({
                                                               ...prev,
                                                               id_number_of_representative: e.target.value
                                                           }))
                                                       }
                                                   }}
                                                   placeholder={language[lang].auth.signUp.accountType.identification_codePlaceholder}/>
                                            {errors.id_number_of_representative &&
                                                <p className={"form-error-message"}>{language[lang].auth.signUp.accountType.errors.required}</p>}
                                        </div>
                                        <div className={"signup-step-buttons"}>
                                            <Button
                                                onClick={() => setStep(1)}>{language[lang].auth.signUp.accountType.prev}</Button>
                                            <Button onClick={handlers.doneThirdStepLegal}
                                                    variant={"contained"}>{language[lang].auth.signUp.accountType.next}</Button>
                                        </div>
                                    </div>
                                }
                                {
                                    step === 3 && <div className={"signup-step-four"}>
                                        <div className={"form-group"} style={{marginTop: "40px"}}>
                                            <label
                                                className={"form-label"}>{language[lang].auth.signUp.accountType.city}</label>
                                            <select className={"form-control"} onChange={(e) => {
                                                setSignupForm((prev) => ({...prev, city: e.target.value}));
                                            }}>
                                                
                                                {
                                                    cities.map((c) => <option key={c.id} value={c.name}>{c.name}</option>)
                                                }
                                            </select>
                                            {errors.city &&
                                                <p className={"form-error-message"}>{language[lang].auth.signUp.accountType.errors.required}</p>}
                                        </div>
                                        {(signupForm.city === "Tbilisi" || signupForm.city === "თბილისი") && <div className={"form-group"} style={{marginTop: "20px"}}>
                                            <label
                                                className={"form-label"}>{language[lang].auth.signUp.accountType.district}</label>
                                            <select className={"form-control"} value={signupForm.district} onChange={(e) => {
                                                setSignupForm((prev) => ({...prev, district: e.target.value}));
                                            }}>
                                                <option
                                                    value={""}>{language[lang].auth.signUp.accountType.selectDistrict}</option>
                                                {
                                                    districts.map((c, k) => <option key={k} value={c}>{c}</option>)
                                                }
                                            </select>
                                            {errors.district &&
                                                <p className={"form-error-message"}>{language[lang].auth.signUp.accountType.errors.required}</p>}
                                        </div>}
                                        <div className={"form-group"} style={{marginTop: "20px"}}>
                                            <label
                                                className={"form-label"}>{language[lang].auth.signUp.accountType.address}</label>
                                            <input type={"text"} value={signupForm.address} className={"form-control"}
                                                   onChange={(e) => {
                                                       setSignupForm((prev) => ({
                                                           ...prev,
                                                           address: e.target.value
                                                       }))
                                                   }}
                                                   placeholder={language[lang].auth.signUp.accountType.addressPlaceholder}/>
                                            {errors.address &&
                                                <p className={"form-error-message"}>{language[lang].auth.signUp.accountType.required}</p>}
                                        </div>
                                        <div className={"form-group"} style={{marginTop: "20px"}}>
                                            <label
                                                className={"form-label"}>{language[lang].auth.signUp.accountType.phone}*</label>
                                            <div
                                                style={{display: "flex", alignItems: "center", justifyContent: "flex-end"}}>
                                                <input type={"text"} value={signupForm.phone} className={"form-control"}
                                                       style={{paddingRight: "70px"}}
                                                       onChange={(e) => setSignupForm((prev) => ({
                                                           ...prev,
                                                           phone: e.target.value
                                                       }))}
                                                       placeholder={language[lang].auth.signUp.accountType.phonePlaceholder}
                                                       onBlur={() => {
                                                           handlers.validate("phone", signupForm.phone);
                                                       }}/>
                                                <button className="verify-button" onClick={handlers.sendCodeToPhone}>
                                                    <SendIcon style={{color: "white"}}/>
                                                </button>
                                            </div>
                                            {errors.phone &&
                                                <p className={"form-error-message"}>{language[lang].auth.signUp.accountType.errors.phoneAvailable}</p>}
                                            {errors.confirm_phone &&
                                                <p className={"form-error-message"}>{language[lang].auth.signUp.accountType.errors.verifyPhone}</p>}
                                            {showVerifyPhone && <div style={{
                                                display: "flex",
                                                alignItems: "center",
                                                marginTop: "20px",
                                                justifyContent: "space-between"
                                            }}>
                                                <input type={"text"}
                                                       onChange={(e) => setVerify((prev) => ({
                                                           ...prev,
                                                           phone: e.target.value
                                                       }))}
                                                       placeholder={"Enter code"} className={"form-control"}
                                                       style={{width: "calc(100% - 120px)"}}/>
                                                <Button
                                                    onClick={handlers.confirmPhone}>{language[lang].auth.signUp.accountType.confirm}</Button>
                                            </div>}
                                        </div>
                                        <div className="accept-terms-and-cond">
                                            <input type="checkbox" id="agree-terms-and-cond" onChange={() => setAccepted(!accepted)}/>
                                            <label htmlFor="agree-terms-and-cond" >ვეთანხმები </label>&nbsp; <span onClick={() => setShowTermsAndCond(true)}> წესებს და პირობებს</span>
                                        </div>
                                        {errors.accepted &&
                                                <p className={"form-error-message"}>{language[lang].auth.signUp.accountType.errors.accepted}</p>}
                                        <div style={{display: "flex", justifyContent: "space-between"}}>
                                            <Button onClick={() => setStep(2)}
                                                    style={{marginTop: "25px"}}>{language[lang].auth.signUp.accountType.prev}</Button>
                                            <Button variant={"contained"} disabled={!(signupForm.city !== "" && signupForm.address !== "" && (signupForm.district !== "" || signupForm.city !== "Tbilisi") && errors.confirm_phone === false)} onClick={handlers.signUp}
                                                    style={{marginTop: "25px"}}>{language[lang].auth.signUp.accountType.finish}</Button>
                                        </div>
                                    </div>
                                }
                            </>

                        </div>
                        <div className={"signup-backdrop"} onClick={() => setShowSignup(false)}>

                        </div>
                    </>
                </Zoom>
            </div>
            <Modal show={showTermsAndCond} size="lg" onHide={() => setShowTermsAndCond(false)}>
                <Modal.Body>
                    <TermsAndCond/>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default SignUp;